import { useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult } from 'react-query';
import {
  getTranslationConsentContent,
  getTranslationConsentUserAcknowledge,
  saveTranslationConsentUserAcknowledge,
  TranslationConsentContent,
  TranslationConsentUserAcknowledge,
  TranslationConsentUserAcknowledgeParams,
} from '../../services/consent/translationConsent.service';
import useFetchUserProfile from '../profile/useFetchUserProfile';
import { queryKeys } from '../queryKeyFactory';

export const useTranslationConsentContent = (enabled: boolean): UseQueryResult<TranslationConsentContent, Error> => {
  return useQuery<TranslationConsentContent, Error>(
    [queryKeys.translationConsent.content],
    async () => {
      return getTranslationConsentContent();
    },
    {
      enabled,
    }
  );
};

export const useTranslationConsentUserAcknowledge = (
  enabled: boolean
): UseQueryResult<TranslationConsentUserAcknowledge | null, Error> => {
  const { data: profile } = useFetchUserProfile();

  return useQuery<TranslationConsentUserAcknowledge | null, Error>(
    [queryKeys.translationConsent.userAcknowledge],
    async () => {
      return getTranslationConsentUserAcknowledge(profile?.userId!);
    },
    {
      enabled: !!profile?.userId && enabled,
    }
  );
};

export const useSaveTranslationConsentUserAcknowledge = (): UseMutationResult<
  void,
  void,
  TranslationConsentUserAcknowledgeParams
> => {
  const queryClient = useQueryClient();
  const { data: profile } = useFetchUserProfile();

  return useMutation(
    async (payload) => {
      await saveTranslationConsentUserAcknowledge(profile?.userId!, payload);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries([queryKeys.translationConsent.userAcknowledge]);
      },
    }
  );
};
